<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path
    d="m11.87 2a10.164 10.164 0 0 0 -5.7 1.752l-1.463-1.458a1 1 0 0 0 -1.707.706v5a1 1 0 0 0 1 1h5a1 1 0 0 0 .707-1.707l-.621-.621a6.126 6.126 0 0 1 8.914 5.328 6.145 6.145 0 0 1 -12.065 1.5 2 2 0 0 0 -3.87 1.01 10.144 10.144 0 0 0 19.935-2.51 10.077 10.077 0 0 0 -10.13-10z"
    [attr.fill]="fill"
  />
</svg>
